export default function AadharVerifiedCard({aadharVerifiedCard}) {
    return (
        <div className="col-md-6 border col">
            <span className="verified-text"><i className="far fa-clock"></i> Verified</span>
            <div className="info">
                <h3>Aadhar</h3>
                <h5>xxxx xxxx xxxx xxxx</h5>
                <p>ID Proof</p>
                {aadharVerifiedCard ? '22324' : 'sdfsdfdf'}
            </div>
            <div className="col-md-3 icons-wrap">
                <span className="icons"><i className="fas fa-edit"></i></span>
                <span className="icons"><i className="fas fa-trash"></i></span>
            </div>
        </div>
    )
}